
import { Component, Prop, Vue } from 'vue-property-decorator';
import { FtpUser } from '@/services/FtpUser/interfaces';

@Component
export default class DeleteFtpUserDialog extends Vue {
  @Prop()
  public ftpUser!: FtpUser;
  @Prop()
  public readonly onDelete!: CallableFunction;

  public visible: boolean = true;

  get message(): string {
    return `Are you sure you want to remove FTP User ${this.ftpUser.username}?`;
  }

  public destroyComponent(): void {
    this.$emit('close');
  }

  public async deleteFtpUser(): Promise<void> {
    this.$emit('delete', this.ftpUser);
    this.destroyComponent();
  }
}
